export const roles = {
  hrLead: 'HR_LEAD',
  hrContact: 'HR_CONTACT',
  beneficiary: 'BENEFICIARY',
  manager: 'MANAGER',
  internal: 'INTERNAL',
  networkPartner_l1: 'NETWORK_PARTNER_L1',
  networkPartner_l2: 'NETWORK_PARTNER_L2',
  networkPartner_l3: 'NETWORK_PARTNER_L3',
};
